<template>
  <div>
    <DashboardHeader title="Video Tutorials">
      <div class="mx-10 mt-8">
        <VideoTiles :videos="videos" vidPath="/videos/bitsems-video-tutorials/"></VideoTiles>
      </div>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import VideoTiles from "@/components/myLibrary/VideoTiles.vue";

export default {
  components: { DashboardHeader, VideoTiles },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    }
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/bitsems-video-tutorials", this.getAccessToken)
      .then(videos => {
        this.$store.commit("setLoader", false);
        this.videos = videos;
      });
  },
  data() {
    return {
      videos: []
    };
  }
};
</script>

<style>
</style>